// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.custom-group_ac2e5783 {
  display: grid;
  grid-template-columns: auto 1fr;
  row-gap: 0.667rem;
  width: 100%;
}
.custom-group__row_ac2e5783 {
  display: flex;
  width: fit-content;
}
.custom-group__row_error_ac2e5783 .custom-group__cell_ac2e5783:first-child {
  color: #b32700;
  border-color: #b32700;
  background-color: #fff;
  box-shadow: none;
}
.custom-group__row_ac2e5783:focus-within {
  outline-style: solid;
  outline-offset: 1px;
  outline-width: 2px;
  outline-color: #1d5080;
  box-shadow: 0 0 0 4px #fff;
  border-radius: 0.167em;
}
.custom-group__row_ac2e5783:focus-within .input__root {
  outline: none;
  box-shadow: none;
}
.custom-group__row_ac2e5783:focus-within .custom-group__cell_ac2e5783:first-child {
  color: #11304d;
  border-color: #1d5080;
  background-color: #fff;
}
.custom-group__row_ac2e5783:hover:not(:focus-within):hover {
  box-shadow: 0 0 0 0.167rem #c4edeb;
  border-radius: 0.167em;
}
.custom-group__row_ac2e5783:hover:not(:focus-within) .custom-group__cell_ac2e5783:first-child {
  border-color: #1d5080;
}
.custom-group__row_ac2e5783:hover:not(:focus-within) .custom-group__cell_ac2e5783:last-child .input__root {
  border-color: #1d5080;
  box-shadow: none;
}
.custom-group_ac2e5783 .custom-group__row_ac2e5783 {
  display: grid;
  grid-template-columns: subgrid;
  grid-column: 1/-1;
}
.custom-group__cell_ac2e5783 {
  position: relative;
}
.custom-group__cell_ac2e5783:first-child {
  z-index: 10;
  margin-bottom: 0;
  border: 0.084rem solid #84919b;
  background-color: #fff;
  border-radius: 0.167em 0 0 0.167em;
}
.custom-group__cell_ac2e5783:last-child .input__root {
  border-left: none;
  border-radius: 0 0.167em 0.167em 0;
}
.custom-group__label_ac2e5783 {
  display: inline-flex;
  height: 100%;
  width: 100%;
  padding: 0 1.334rem;
  font-weight: 600;
  align-items: center;
}
.custom-group__label-wrapper_ac2e5783 {
  height: 100%;
  margin-bottom: 0;
}
`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"custom-group": `custom-group_ac2e5783`,
	"custom-group__row": `custom-group__row_ac2e5783`,
	"custom-group__row_error": `custom-group__row_error_ac2e5783`,
	"custom-group__cell": `custom-group__cell_ac2e5783`,
	"custom-group__label": `custom-group__label_ac2e5783`,
	"custom-group__label-wrapper": `custom-group__label-wrapper_ac2e5783`
};
export default ___CSS_LOADER_EXPORT___;
